import React from 'react';
import {twMerge} from 'tailwind-merge';

import {ColorPaletteGradient} from './ColorPaletteGradient';
import {ColorPaletteSegments} from './ColorPaletteSegments';

export const ColorPalettePreview = ({
  colors,
  borderClassName,
  className,
  mode = 'segments',
  'data-test': dataTest,
}: {
  colors: readonly string[];
  borderClassName?: string;
  className?: string;
  mode?: 'segments' | 'gradient';
  'data-test'?: string;
}) => {
  return (
    <div
      data-test={dataTest}
      className={twMerge(
        'w-full rounded-2xl p-8 outline outline-1 outline-moon-250 dark:outline-moon-750',
        borderClassName
      )}>
      {mode === 'gradient' ? (
        <ColorPaletteGradient colors={colors} className={className} />
      ) : (
        <ColorPaletteSegments colors={colors} className={className} />
      )}
    </div>
  );
};
